@if (dataService.loading) {
<div class="spinner-container">
  <mat-spinner></mat-spinner>
</div>
}

<div class="audit-header">
  <mat-form-field class="search-pub">
    <mat-label>Search Product</mat-label>
    <input
      matInput
      type="text"
      [(ngModel)]="searchWord"
      (input)="searchThis($event.target.value)"
    />
  </mat-form-field>
  <mat-icon>search</mat-icon>
  @if (stateList !== null) {
  <mat-form-field appearance="fill" class="selectState">
    <mat-label>State difference</mat-label>
    <mat-select
      [value]="selectedState"
      (selectionChange)="onSelectStateChange($event)"
    >
      @for (st of stateList; track st) {
      <mat-option [value]="st">{{ st }}</mat-option>
      }
    </mat-select>
  </mat-form-field>
  }
</div>

<mat-tree
  [dataSource]="dataSource"
  [treeControl]="treeControl"
  class="button-row"
>
  <mat-tree-node
    *matTreeNodeDef="let node"
    matTreeNodePadding
    class="node-column"
  >
    <button mat-icon-button disabled
      ><mat-icon class="mat-icon-rtl-mirror" style="visibility: hidden"
        >chevron_right</mat-icon
      ></button
    ><span [innerHTML]="node.item"></span>
    @if (node.level > 3 && !node.item.startsWith('SD')) {
    <button
      class="button-action"
      matTooltip="Display guide note"
      matTooltipClass="tooltip2"
      (click)="onDisplayGuidenote(node.key)"
    >
      Guide Note
    </button>
    }
  </mat-tree-node>

  <mat-tree-node
    *matTreeNodeDef="let node; when: hasChild"
    matTreeNodePadding
    class="spinner-container"
  >
    @if (!node.item.startsWith('SD')) {
    <button
      mat-icon-button
      [attr.aria-label]="'click to toggle'"
      matTreeNodeToggle
    >
      <mat-icon class="mat-icon-rtl-mirror">
        {{ treeControl.isExpanded(node) ? "expand_more" : "chevron_right" }}
      </mat-icon>
    </button>
    }
    <span [innerHTML]="node.item"></span>
    @if (node.isLoading) {
    <mat-spinner
      mode="indeterminate"
      class="example-tree-progress-bar"
    ></mat-spinner>
    }
  </mat-tree-node>
</mat-tree>
